import React from "react";
import { Route, Routes } from "react-router-dom";
// import Home from "./containers/Home";
import Login from "./containers/Login";
import Notes from "./containers/Notes";
import Signup from "./containers/Signup";
import Home from "./containers/Home";
import NewNote from "./containers/NewNote";
import Settings from "./containers/Settings";
import Calendar from "./containers/Calendar";
import GPT from "./containers/GPT";
import Dalle from "./containers/Dalle";
import ThreeScene from "./containers/ThreeScene";
import ScrollAnim from "./containers/ScrollAnim";
import NotFound from "./containers/NotFound";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

export default function Links() {
  return (
    <Routes>
      <Route path="/" element={<ThreeScene />} />
      <Route
        path="/login"
        element={
          <UnauthenticatedRoute>
            <Login />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <UnauthenticatedRoute>
            <Signup />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/calendar"
        element={
          <AuthenticatedRoute>
            <Calendar />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/gpt"
        element={
          <AuthenticatedRoute>
            <GPT />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/dalle"
        element={
          <AuthenticatedRoute>
            <Dalle />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/threeScene"
        element={
          <UnauthenticatedRoute>
            <ThreeScene />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/scrollAnim"
        element={
          <AuthenticatedRoute>
            <ScrollAnim />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <AuthenticatedRoute>
            <Settings />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/notes"
        element={
          <AuthenticatedRoute>
            <Home />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/notes/new"
        element={
          <AuthenticatedRoute>
            <NewNote />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/notes/:id"
        element={
          <AuthenticatedRoute>
            <Notes />
          </AuthenticatedRoute>
        }
      />
      {/* Finally, catch all unmatched routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
